import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import Table from 'antd/lib/table';
import Select from 'antd/lib/select';
import { ResponsiveTable, OpenFileLink } from '../../../common/components/data-display';
import { allocationStatus, allocationStatusT, settingKeys } from '../../../common/enums';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import { Input, Button, message } from 'antd';
import {
   sellAllocationsActions
} from '../ducks'
import rules from '../../../common/rules/rules';
import Form from 'antd/lib/form';
import { selectSettingNumeric } from '../../../features/settings/ducks';
import AllocationSplitForm from './AllocationSplitForm';

const { Column } = Table;
const { Option } = Select;
const { Item } = Form;

const mapStateToProps = state => ({
  allocationTransferFee: selectSettingNumeric(state, settingKeys.CREDITOR_ALLOCATION_TRANSFER_FEE),
})

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators(
    {
      sellAllocations: sellAllocationsActions.request,
    },
    dispatch
  ),
});

@translate()
@Form.create()
@connect(mapStateToProps, mapDispatchToProps)
export default class AllocationList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    allocations: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    token: PropTypes.string,
    accountId: PropTypes.string,
  };

  state = {
    amountToBuy: 0,
    mapOfInvestmentsToSell: new Map(),
    mark: true,
    default: 100,
    selectedRowKeys: []
  };


  getLeftOfAmount = (allocation, ratio) => {
    // TODO math
    if(Number(allocation.amountInvested === 0)){
      return ((Number(allocation.amount)*ratio)/100).toFixed(2)
    }
    else {
      return (((Number(allocation.amount)-Number(allocation.amountInvested)+Number(allocation.amountPrincipalUnpaid))*ratio)/100).toFixed(2)
    }
  }


  onSubmit = e => {
    e.preventDefault()
    const {action, accountId, form} = this.props;

    form.validateFields((err,values) => {
      if(!err){
        if(this.state.amountToBuy === 0){
          message.error('Predávané investície musia mať nenulovú hodnotu')
        }
        else {
          action.sellAllocations({body: this.state.mapOfInvestmentsToSell, accountId: accountId, buyer: values.buyer, totalAmount: this.state.amountToBuy, ratio: this.state.default})
          this.setState({
            amountToBuy: 0,
            mapOfLoansToSell: new Map()
          });
        }

      }
    })
  }

  calculateSellAmount = ratio => {
    let {amountToBuy, mapOfInvestmentsToSell} = this.state;
    let {allocations} = this.props
    amountToBuy = 0;
    mapOfInvestmentsToSell.forEach((value, key) => {
      amountToBuy += (Number(value.amount)*Number(ratio))/100;
      let input = document.getElementById(`inp${key}`);
      input.value = (Number(value.amount)*Number(ratio))/100
      mapOfInvestmentsToSell.set(key, {
        amount: input.value,
      })

    });
    //update all allocations selling price
    allocations.forEach((allocation) => {
      let input = document.getElementById(`inp${allocation.id}`);
      input.value = this.getLeftOfAmount(allocation, Number(ratio))
    })

    this.setState({
      amountToBuy,
      default: Number(ratio)
    })


  }

  helpGenerator = (allocation, comp) => {
      if (comp === 'input') {
        return <Input id={`inp${allocation.id}`} className="amountToBuyField" defaultValue={this.getLeftOfAmount(allocation, this.state.default)}  onChange={this.onChange} ></Input>
      }
  };

  onChange = e => {
    let {amountToBuy, mapOfInvestmentsToSell} = this.state;
    amountToBuy = 0

    let key = e.target.id

    //if id of target is present and values are different, rewrite value
    if(mapOfInvestmentsToSell.get(key.substring(3))){
      let input = document.getElementById(`${key}`);
      if (Number(input.value) !== mapOfInvestmentsToSell.get(key.substring(3)).amount){
        mapOfInvestmentsToSell.set(key.substring(3), {
          amount: input.value,
        })
      }
    }
    mapOfInvestmentsToSell.forEach((value, key) => {
      amountToBuy += Number(value.amount);
    });
    this.setState({ amountToBuy, mapOfInvestmentsToSell });
  }

  onSelectChange = (selectedRowKeys, row) => {
    let {amountToBuy, mapOfInvestmentsToSell} = this.state;
    amountToBuy = 0
    for(let key of selectedRowKeys){
      //if id is not present in map, add it
      if(!mapOfInvestmentsToSell.get(key)){
        let input = document.getElementById(`inp${key}`);
        mapOfInvestmentsToSell.set(key, {
          amount: input.value,
        })
      }
    }

    let investmentsToDelete = Array.from(mapOfInvestmentsToSell.keys()).filter(x => !selectedRowKeys.includes(x))

    for (let keyToDelete of investmentsToDelete){
      mapOfInvestmentsToSell.delete(keyToDelete)
    }
    mapOfInvestmentsToSell.forEach((value, key) => {
      amountToBuy += Number(value.amount);
    });
    this.setState({ selectedRowKeys,amountToBuy, mapOfInvestmentsToSell });
  }

  render() {
    const {
      allocations,
      pagination,
      filter,
      onTableChange,
      onFilterStatusChange,
      isLoading,
      t,
      token,
      allocationTransferFee,
      form,
      accountId
    } = this.props;
    const { getFieldDecorator } = form;

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: record.allocationSell === true || record.status !== allocationStatus.INVESTED || record.investments.length > 1
      })
    };
    return (
      <div>
        <Row className="filters padded">
          <Col xs={12} md={6}>
            <Select
              placeholder={t('Vybrať stav')}
              onChange={onFilterStatusChange}
              defaultValue={filter.status}
            >
              <Option value="">{t('Všetky stavy')}</Option>
              {Object.entries(allocationStatusT).filter(([key, value]) => key !== allocationStatus.PARTIALLY_INVESTED && key !== allocationStatus.REJECTED).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        { accountId && (
          <Row>
            <Col xs={10} md={8}>
              <AllocationSplitForm
                onSubmit={this.calculateSellAmount}
                calculateSellAmount={this.calculateSellAmount}
              />
            </Col>
          </Row>
        )}


        <ResponsiveTable
          dataSource={allocations}
          rowKey={allocation => allocation.id}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
          rowSelection={accountId ? rowSelection : null}
        >

          {/* <Column
            dataIndex="checked"
            key="checked"
            render={(accountName, allocation, index) => this.helpGenerator(allocation, 'checkBox')}
          />     */}
          <Column
            title={t('Meno investora')}
            dataIndex="accountName"
            key="accountName"
            render={(accountName, loan) => (
              <Link to={`/admin/accounts/${loan.accountId}/profile`}>{accountName}</Link>
            )}
          />
          <Column
            title={t('Suma')}
            dataIndex="amount"
            key="amount"
            render={amount => currencyFormatter(amount)}
          />
          <Column
            title={t('Stav')}
            dataIndex="status"
            key="status"
            render={status => allocationStatusT[status]}
          />
          <Column
            title={t('Dátum vytvorenia')}
            dataIndex="createdAt"
            key="createdAt"
            render={createdAt => formatDateTime(createdAt)}
          />
          {
            accountId && (
              <Column
                title={t('Predajná cena')}
                width="160px"
                dataIndex="loan"
                key="loan"
                render={(name, allocation, index) => this.helpGenerator(allocation, 'input')}
              />
            )
          }
          <Column
            title={t('Akcie')}
            key="action"
            render={(text, allocation) => (
              <span>
                <Link to={`/admin/allocations/${allocation.id}`}>{t('Detail')}</Link>
              </span>
            )}
          />
        </ResponsiveTable>

        {token && (
          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/allocation/report?token=${token}`}
          >
            {t('Export')}
          </OpenFileLink>
        )}
        {
          accountId && (
          <div>
            <Form onSubmit={this.onSubmit}>
              <Item label={t('Poplatok (%)')}>
                {getFieldDecorator('fee', { rules: [...rules.required, rules.number] , initialValue: allocationTransferFee})(
                  <Input size="default" disabled={true} />
                )}
              </Item>
              <Item  label={t('VS kupujúceho investora')}>
                {getFieldDecorator('buyer', { rules: [...rules.required] , initialValue: ''})(
                  <Input size="default" />
                )}
              </Item>
              <h2 size="default" style={{ display: 'inline' }}>{this.state.amountToBuy.toFixed(2)}</h2>
              <Button htmlType='submit' disabled={this.state.mapOfInvestmentsToSell.size === 0} style={{ display: 'inline' }}>Zrealizovať predaj investícií</Button>
            </Form>

          </div>
        )}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocation-management/components/AllocationList.js